/**
 * 阈值（对比 Photoshop 补全第一档缺口 阶段 1）。
 *
 * 灰度化后二值化——跟渐变映射同类："恒等参数"这个约定在这里天然不适用，
 * 新建时画面必然立刻变成黑白（真实 Photoshop 同样如此，默认阈值 128），
 * 不是没做完，是这个调整的核心语义。
 */
export interface ThresholdParams {
  /** 阈值 1–255：灰度 ≥ 阈值输出 255，否则 0。 */
  readonly level: number;
}

export const DEFAULT_THRESHOLD_PARAMS: ThresholdParams = { level: 128 };

function luminance(r: number, g: number, b: number): number {
  return 0.299 * r + 0.587 * g + 0.114 * b;
}

export function applyThreshold(
  r: number,
  g: number,
  b: number,
  params: ThresholdParams,
): [number, number, number] {
  const gray = Math.round(luminance(r, g, b));
  const v = gray >= params.level ? 255 : 0;
  return [v, v, v];
}
